// extracted by mini-css-extract-plugin
export var back = "pager-module--back--f87a6";
export var container = "pager-module--container--92b97";
export var disabled = "pager-module--disabled--3abb1";
export var last = "pager-module--last--d60b8";
export var next = "pager-module--next--0bf81";
export var page = "pager-module--page--2f75f";